import { render, staticRenderFns } from "./WebSiteComingSoon.vue?vue&type=template&id=c6d94dea&"
import script from "./WebSiteComingSoon.vue?vue&type=script&lang=js&"
export * from "./WebSiteComingSoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports